import { faLongArrowDown, faLongArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, GridProps, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { reduceResolution, wbp } from 'Theme';

interface HeaderCellProps extends GridProps {
    title?: string;
    sortDirection?: 'asc' | 'desc';
    onSort?: () => void;
}

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            fontFamily: 'Poppins',
            fontWeight: 600,
            color: '#222222',
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(16)}px`,
                lineHeight: `${reduceResolution(24)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '16px',
                lineHeight: '24px'
            }
        },
        sortable: {
            cursor: 'pointer'
        },
        content: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px'
        }
    })
);

export const HeaderCell: FunctionComponent<HeaderCellProps> = props => {
    const classes = useStyles();
    const { title, sortDirection, onSort, className, ...gridProps } = props;

    return (
        <Grid
            item
            {...gridProps}
            className={clsx(className, {
                [classes.sortable]: !!onSort
            })}
            onClick={onSort}
        >
            <Box className={classes.content}>
                <Typography className={classes.title}>{title}</Typography>
                {sortDirection && <FontAwesomeIcon icon={sortDirection === 'asc' ? faLongArrowUp : faLongArrowDown} />}
            </Box>
        </Grid>
    );
};

export default HeaderCell;
